import React from 'react';
import { View } from 'react-native';

import { map as _map, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import SelectionItem from '../../../../Common/UI/SelectionItem';
import { getThemeImages } from '../../../../Themes';
import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';

import styles from './PlanUsersList.Styles';

function PlanUsersList({
  users,
  onRemovePress,
  images,
  withRemoveUser,
  removeButtonTitle,
  title,
  emptyText,
  ...props
}) {
  const theme = useTheme();
  const numberOfUsers = _get(users, 'length', 0);
  const Images = getThemeImages(theme);

  return (
    <View style={styles.containerStyle}>
      <VFText
        i18nKey={title}
        style={styles.titleTextStyle}
        type="primary"
        testKey={SohoFrameworkTestKeys.PlanNumberOfUsersInPlanTitle}
      />

      {numberOfUsers === 0 && (
        <View style={styles.emptyViewStyle(theme)}>
          <Icon name={Images.icInfoCircle} type="image" size={25} />
          <VFText i18nKey={emptyText} style={styles.emptyTextStyle} />
        </View>
      )}

      {_map(users, user => {
        const { id, name, phoneNumber, icon } = user;
        return (
          <SelectionItem
            key={id}
            title={name}
            subTitle={phoneNumber}
            icon={images?.[icon]}
            withRemove={withRemoveUser}
            onRemovePress={() => onRemovePress(user)}
            removeButtonTitle={removeButtonTitle}
            removeTestKey={SohoFrameworkTestKeys.PlanRemoveUserBtn}
            selectTestKey={SohoFrameworkTestKeys.PlanCBUnassignedUser}
          />
        );
      })}
    </View>
  );
}

PlanUsersList.defaultProps = {
  withRemoveUser: true,
};

PlanUsersList.propTypes = {
  users: PropTypes.array,
  onRemovePress: PropTypes.func,
  images: PropTypes.object,
  withRemoveUser: PropTypes.bool,
  removeButtonTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  emptyText: PropTypes.string,
};

export default PlanUsersList;
